import type { WebhookType } from '@/shared/types/nps';

export const WEBHOOK_TYPES: Record<WebhookType, { title: string; description: string }> = {
  ORDER_PAID: {
    title: 'Pedido pago',
    description: 'Notifica quando um pedido é pago na loja.',
  },
  UNINSTALLED: {
    title: 'Desinstalado',
    description: 'Notifica quando o aplicativo é desinstalado da loja.',
  },
};

export const WEBHOOK_LABEL: Record<WebhookType, string> = {
  ORDER_PAID: WEBHOOK_TYPES.ORDER_PAID.title,
  UNINSTALLED: WEBHOOK_TYPES.UNINSTALLED.title,
};
